var styles = {"dark":"styles_dark__3O3nQ","light":"styles_light__1NEMJ","tooltip":"styles_tooltip__m-tQi"};

export default styles;
//# sourceMappingURL=styles.css.js.map
